var map = {
	"./img_0.png": 682,
	"./img_1.png": 683,
	"./img_2.png": 684,
	"./img_3.png": 685,
	"./img_4.png": 686,
	"./img_5.png": 687,
	"./img_6.png": 688,
	"./img_7.png": 689,
	"./img_8.png": 690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 681;